import { Alert, Box, Button, Typography } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import { useTranslation } from "react-i18next";

const ErrorState = ({
  title,
  description,
  onRetry,
  compact = false,
}) => {
  const { t } = useTranslation();
  const resolvedTitle = title || t("common.loadError");
  const resolvedDescription = description || t("common.loadErrorDescription");

  if (compact) {
    return (
      <Alert
        severity="warning"
        action={onRetry ? <Button color="inherit" size="small" startIcon={<RefreshOutlinedIcon />} onClick={onRetry}>{t("common.retry")}</Button> : null}
        sx={{ mb: 2, alignItems: "center" }}
      >
        <Typography variant="body2" fontWeight={700}>{resolvedTitle}</Typography>
        <Typography variant="caption" display="block">{resolvedDescription}</Typography>
      </Alert>
    );
  }

  return (
    <Box sx={{ display: "grid", placeItems: "center", textAlign: "center", gap: 1, py: 6, px: 2 }}>
      <Typography variant="h6" color="text.primary">{resolvedTitle}</Typography>
      <Typography variant="body2" color="text.secondary">{resolvedDescription}</Typography>
      {onRetry && <Button variant="contained" startIcon={<RefreshOutlinedIcon />} onClick={onRetry}>{t("common.retry")}</Button>}
    </Box>
  );
};

export default ErrorState;
